import { render, staticRenderFns } from "./RetailOrders.vue?vue&type=template&id=4539c4d6"
import script from "./RetailOrders.vue?vue&type=script&lang=js"
export * from "./RetailOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports